module.exports = __webpack_public_path__ + "static/media/main-mart.9ccffb64.png";